import { createApiClient } from '@deltax/idp-api-client';

export const { apiClient, authService } = createApiClient({
  clientId: process.env.VUE_APP_CLIENT_ID,
  resourceApiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  idpBaseUrl: process.env.VUE_APP_IDP_BASE_URL,
  proxyBaseUrl: window.location.origin + '/idp',
  errorHandler: error => {
    if (error.name === 'AuthRefreshError') {
      import('@/store')
        .then(({ default: store }) => {
          return store.dispatch('handleAuthFailure');
        })
        .catch(() => {
          console.error('Unable to complete expired-session handling.');
        });
    }
  }
});

export const axiosInstance = apiClient.axiosInstance;

export async function authorize(prompt = 'none') {
  const callbackUri = window.location.origin + '/callback';

  const authorizationUrl = await authService.createAuthorizationUrl(
    callbackUri,
    prompt,
    process.env.VUE_APP_RESOURCE
  );

  window.location.assign(authorizationUrl);
}